

export default function getPaymentMethod(method) {
    if (method === "direct_debit") return "Lastschrift";
    else if (method === "payment_sepa_direct_debit") return "Lastschrift";
    else if (method === "payment_cash") return "Barzahlung";
    else return "Überweisung";
}
